const isTouchDevice =
  window.matchMedia('(hover: none), (pointer: coarse)').matches || navigator.maxTouchPoints > 0;

function getZoomContainer(image) {
  return image.closest('.product__media, .product-media-modal__content, .media, .product-media-container') || image.parentElement;
}

function getSpinner(image) {
  return image.parentElement?.parentElement?.querySelector('.loading__spinner') || null;
}

function removeOverlay(image) {
  const container = getZoomContainer(image);
  container?.querySelector('.image-magnify-full-size')?.remove();
  image.style.opacity = '1';
  document.body.classList.remove('overflow-hidden');
}

function createOverlay(image) {
  const overlay = document.createElement('div');
  overlay.className = 'image-magnify-full-size';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  overlay.style.backgroundColor = 'var(--gradient-background)';
  overlay.style.backgroundRepeat = 'no-repeat';
  overlay.style.backgroundPosition = 'center center';
  overlay.style.backgroundSize = 'contain';
  return overlay;
}

function moveWithPointer(image, overlay, event, zoomRatio) {
  const rect = image.getBoundingClientRect();
  const xPosition = Math.max(0, Math.min(event.clientX - rect.left, rect.width));
  const yPosition = Math.max(0, Math.min(event.clientY - rect.top, rect.height));
  const xPercent = rect.width ? `${(xPosition / rect.width) * 100}%` : '50%';
  const yPercent = rect.height ? `${(yPosition / rect.height) * 100}%` : '50%';

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${Math.max(image.naturalWidth || image.width, rect.width) * zoomRatio}px`;
}

function openZoom(image, zoomRatio, event) {
  const container = getZoomContainer(image);
  if (!container) return;

  removeOverlay(image);

  const spinner = getSpinner(image);
  const overlay = createOverlay(image);

  image.style.opacity = '0.55';
  spinner?.classList.remove('hidden');

  const attachOverlay = () => {
    spinner?.classList.add('hidden');
    container.appendChild(overlay);
    document.body.classList.add('overflow-hidden');
    if (event) moveWithPointer(image, overlay, event, zoomRatio);
  };

  if (image.complete) {
    attachOverlay();
  } else {
    image.addEventListener('load', attachOverlay, { once: true });
  }

  overlay.addEventListener('click', () => removeOverlay(image));
  overlay.addEventListener('mousemove', (moveEvent) => moveWithPointer(image, overlay, moveEvent, zoomRatio));
  overlay.addEventListener('mouseleave', () => {
    overlay.style.backgroundPosition = 'center center';
  });
}

function bindZoom(selector, zoomRatio) {
  document.querySelectorAll(selector).forEach((image) => {
    image.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openZoom(image, zoomRatio, event);
    });
  });
}

if (!isTouchDevice) {
  bindZoom('.image-magnify-lightbox', 2);
  bindZoom('.image-magnify-hover', 2);
}
